module.exports = __webpack_public_path__ + "static/media/profile-default.55f7156a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile-default.png
// module id = 391
// module chunks = 0